export default class ListData {

  constructor(total, items) {
    this._total = total;
    this._items = items;
  }

  get total() {
    return this._total;
  }

  get items() {
    return this._items;
  }

  add(item) {
    if (Array.isArray(item)) {
      for (let i = 0; i < item.length; i++) {
        this._items.push(item[i]);
      }
    } else {
      this._items.push(item);
    }
    this.checkTotal();
  }

  checkTotal() {
    if (this._items.length > this._total) {
      this._total = this._items.length;
    }
  }
}
